import { Routes } from '@angular/router';
import { authGuard } from '../shared/guards/auth.guard';
import { appAccessGuard } from '../shared/guards/app-access.guard';

export const routes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('../protected-area/protected-area.routes').then((m) => m.PROTECTED_ROUTES),
    canActivate: [authGuard, appAccessGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('../public-area/public-area.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: '',
    redirectTo: 'app/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'app/dashboard',
  },
];
